import apiClient from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { Step1FormData, Step2FormData, OnboardingStatus } from '../types'

export const onboardingApi = {
  getStatus: () =>
    apiClient.get<ApiResponse<OnboardingStatus>>('/onboarding/status'),

  postStep1: (data: Step1FormData) =>
    apiClient.post<ApiResponse<null>>('/onboarding/step/1', data),

  postStep2: (data: Step2FormData) =>
    apiClient.post<ApiResponse<null>>('/onboarding/step/2', data),

  postStep3: () =>
    apiClient.post<ApiResponse<null>>('/onboarding/step/3', {}),
}
